import { render, staticRenderFns } from "./EntityDatumRow.vue?vue&type=template&id=332ab013&scoped=true"
import script from "./EntityDatumRow.vue?vue&type=script&lang=js"
export * from "./EntityDatumRow.vue?vue&type=script&lang=js"
import style0 from "./EntityDatumRow.vue?vue&type=style&index=0&id=332ab013&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332ab013",
  null
  
)

export default component.exports